import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";

const SimpleDesignLinkButton = ({ label, tabIndex, size = "standard" }) => {
  const { simpleDesign } = useAccessibilityContext();

  const intl = useIntl();

  if (simpleDesign) {
    return (
      <button
        className={`simple-design-button ${size}`}
        aria-label={intl.formatMessage({ id: "learn_more" })}
        tabIndex={tabIndex}
      >
        <FormattedMessage id={label || "learn_more"} />
      </button>
    );
  }
}

export default SimpleDesignLinkButton;